<!-- View toggle currently used by the commercial properties list/map switcher. -->
<template>
  <div class="flex items-center justify-center lg:justify-start text-gray700 w-full lg:w-auto mb-25 lg:mb-0">

    <template v-for="(option, key, index) in options" :key="index">
      <div v-if="index !== 0" class="w-3px h-3px mx-15 rounded-full bg-gray200"></div>
      <span
        @click="$emit('switch-toggle', key)"
        class="py-3 bg-transparent outline-none ts-all hover:text-gray900 border-t-none border-b border-solid border-transparent hover:border-gray200"
        :class="toggledOption == key ? 'border-gray400' : 'cursor-pointer'"
      >{{ option }}</span>
    </template>

  </div>
</template>

<script>
export default {
  emits: ['switch-toggle'],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    toggledOption: {
      type: String,
      default: ''
    }
  }
};
</script>
